import { application } from 'src';
import { Controller } from '@hotwired/stimulus';
import { API } from 'src/api';
import { find, findAll } from '@fretadao/f-js-dom';


application.register(
  'calculate-route-destination-time',
  class extends Controller {
    static values = { agreement: String };
    static targets = [
      'requestType',
      'selectedLinesPool',
      'destinationField',
      'scheduleDepartureField'
    ];

    calculateAll({ target }) {
      if (this.requestTypeTarget.value != 'destination_change') return;

      this.destinationId = target.value;
      this.#calculateTime(true);
    }

    calculateLine(_event) {
      this.#calculateTime(false);
    }

    resetFields({ target }) {
      if (!target.checked) {
        this.#clearAllTargetSchedules();
      }
    }

    #clearAllTargetSchedules() {
      findAll(`[id^='target-schedule']`).forEach((cell) => cell.innerHTML = '-');
    }

    #calculateTime(force = false) {
      if (this.requestTypeTarget.value != 'destination_change') return;

      let query = '';

      if (force) {
        query = 'tr input[type="checkbox"]';
      } else {
        query = 'tr:not([data-destination-route-calculated="true"]) input[type="checkbox"]';
      }

      const checkboxElements = findAll(query, this.selectedLinesPoolTarget);
      const lineIds = checkboxElements.map((checkboxEl) => {
        const lineId = JSON.parse(checkboxEl.value)?.line_id;
        checkboxEl.dataset.lineId = lineId;
        return lineId;
      });

      const rowElements = findAll('tbody tr:not([data-destination-route-calculated="true"])', this.selectedLinesPoolTarget);
      rowElements.forEach((rowEl) => {
        findAll('td', rowEl)[5].innerHTML = `<span class="italic text-gray-500 animate-pulse">Calculando rotas...</span>`;
      })

      if (lineIds.length === 0) return;

      if (this.destinationFieldTarget.value) {
        this.#calculate(this.destinationFieldTarget.value, lineIds);
      }
    }

    #calculate(destinationId, lineIds) {
      this.csrfToken = find("meta[name='csrf-token']").content;

      API.b2bAdmin.calculateNewDestinationTimes(
        this.agreementValue,
        destinationId,
        lineIds,
        this.csrfToken
      )
        .then((res) => {
          this.#setDeltaTimeToLines(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    unsetCalculatedData(event) {
      event.detail.forEach((lineId) => {
        const checkboxEl = find(`td input[type="checkbox"][data-line-id="${lineId}"]`, this.selectedLinesPoolTarget);
        if (checkboxEl) checkboxEl.removeAttribute('data-destination-route-calculated');
      });
    }

    #setDeltaTimeToLines(routingData) {
      routingData.lines.forEach((lineRouting) => {
        const targetCheckboxEl = find(`input[type="checkbox"][data-line-id="${lineRouting.id}"]`, this.selectedLinesPoolTarget);
        const targetRowEl = targetCheckboxEl.closest('tr');
        const newScheduleCell = findAll('td', targetRowEl)[5];
        const itemData = JSON.parse(targetCheckboxEl.value);

        itemData.new_destination_time_diff = lineRouting.route_time_diff;
        itemData.new_destination_route_length = lineRouting.new_segment_distance;
        itemData.new_destination_arrival_schedule = lineRouting.eta;
        targetCheckboxEl.value = JSON.stringify(itemData);

        newScheduleCell.innerHTML = `${lineRouting.eta} (${this.#formatDiffTime(lineRouting.route_time_diff)})`;
        targetRowEl.dataset.destinationRouteCalculated = true;
      });
    }

    #formatDiffTime = (seconds = 0) => {
      const d = Number(seconds);
      const h = Math.floor(d / 3600);
      const m = Math.floor((d % 3600) / 60);
      const mDisplay = m > 0 ? `${String(m).padStart(2, '0')}` : '00';
      const diff = h != 0 ? `${h}h${mDisplay}min` : `${mDisplay}min`;

      return seconds > 0 ? `+${diff}` : diff;
    };
  }
);
